import { Inject, Injectable, Optional } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  // AngularFire resolves Analytics to null outside the browser, so this is null
  // during SSR and prerendering. Every event goes through log() to keep that
  // case handled in one place.
  constructor(@Optional() @Inject(Analytics) private analytics: Analytics | null) {}

  logLogin(method: string): void {
    this.log('login', { method });
  }

  logDocumentUpload(documentType: string): void {
    this.log('upload_document', { document_type: documentType });
  }

  logComplianceRefresh(scope: 'user' | 'group' | 'all'): void {
    this.log('compliance_refresh', { scope });
  }

  logSearch(searchIndex: string): void {
    this.log('search', { search_index: searchIndex });
  }

  logGroupSwitch(): void {
    this.log('group_switch');
  }

  private log(eventName: string, params?: Record<string, unknown>): void {
    if (!this.analytics) {
      return;
    }

    logEvent(this.analytics, eventName, params);
  }
}
